import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'transaction-history-item:activate-transaction-label:transaction': {
    id: 'transaction-history-item:activate-transaction-label:transaction',
    defaultMessage: 'Transaction',
    description: 'Label for transaction history item -> Activate transaction',
  },
  'transaction-history-item:activate-transaction-label:order-ahead': {
    id: 'transaction-history-item:activate-transaction-label:order-ahead',
    defaultMessage: 'Online Order',
    description: 'Label for transaction history item -> Order Ahead transaction',
  },
  'transaction-history-item:activate-transaction-label:cancelled': {
    id: 'transaction-history-item:activate-transaction-label:cancelled',
    defaultMessage: 'Canceled Order',
    description: 'Label for transaction history item -> Cancelled transaction',
  },
  'transaction-history-item:points-change-label:default': {
    id: 'transaction-history-item:points-change-label:default',
    defaultMessage: 'Points Change',
    description: 'Label for transaction history item -> Points Change (Default label)',
  },
  'transaction-history-item:points-change-label:referral-program-fulfillment': {
    id: 'transaction-history-item:points-change-label:referral-program-fulfillment',
    defaultMessage: 'Referral Program Fulfillment',
    description: 'Label for transaction history item -> Referral Program Fulfillment Points Change',
  },
  'transaction-history-item:points-change-label:activate-transaction': {
    id: 'transaction-history-item:points-change-label:activate-transaction',
    defaultMessage: 'Transaction',
    description: 'Label for transaction history item -> Activate Transaction Points Change',
  },
});
